import gql from 'graphql-tag';

const mutation = gql`
  mutation deleteThematicsSelection($projectId: Int!, $thematicSelectionId: Int!) {
    deleteThematicsSelection(projectId: $projectId, thematicSelectionId: $thematicSelectionId) {
      errors
    }
  }
`;

export default mutation;
